import { render, staticRenderFns } from "./noowner.vue?vue&type=template&id=4689fb3d&scoped=true"
import script from "./noowner.vue?vue&type=script&lang=js"
export * from "./noowner.vue?vue&type=script&lang=js"
import style0 from "./noowner.vue?vue&type=style&index=0&id=4689fb3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4689fb3d",
  null
  
)

export default component.exports